<template>
    <div class="m-view__team">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>三人组队完成桃园结义（其中必须有1个及以上回归玩家），</p>
            <p>完成签到、消费任务即可领取结义值和游戏道具福利</p>
        </div> 
        
        <div class="team-list flex-between-center" v-if="$store.state.team.member.length > 1">            
            <div class="team-item act" v-for="(item,index) in $store.state.team.member" :key="index" :class="'t-'+ (index + 1)">
                <div class="avatar"><img :src="require('@/assets/images/avatar/'+ (index + 1) +'.png')"><div class="label-back" v-if="item.back"></div></div>
                <div class="nickName text-overflow-1">{{ item.nickName }}</div>
            </div>            
            <div class="team-item" v-for="n in ( 3 - $store.state.team.member.length)" :key="'temp-' + n" :class="'t-' + ( $store.state.team.member.length + n)">
                <div class="u-btn add sprite sprite-btn-add_friend" @click="call_invite()"></div>
            </div>
        </div>
        <div class="team-list flex-between-center" v-else>                      
            <div class="team-item" v-for="n in 3" :key="'temp-' + n" :class="'t-'+ n">
                <div class="u-btn add sprite sprite-btn-add_friend" @click="call_invite()"></div>
            </div>
        </div>        

        <div class="u-btn invite sprite sprite-btn-invite" @click="call_invite()"></div>

        <div class="u-btn apply-list sprite sprite-btn-team_apply" :class="{'new' : wait_member.length > 0}" @click="call_apply_list()"></div>

        <div class="notice"><div class="sprite sprite-icon-notice"></div>三人结义小队，至少包含1个回归用户</div>

        <div class="task-view">
            <div class="task-list flex-between-center">
                <div class="list-item" v-for="(item,index) in task_list" :key="index">
                    <div class="task-name sprite" :class="'sprite-t-' + (index + 1)">
                        <p>{{ item.taskName }}</p>
                    </div>

                    <div class="reward-list flex-between-center">
                        <div class="reward-item" v-for="(r,k) in item.rewards" :key="'r-' + k" :class="{'dismiss' : index == 0 ? $store.state.task['t03'].giftRate > 0 : (index == 1 ? $store.state.task['t03'].giftRate == 2 : $store.state.task['t04'].giftRate > 0)}">
                            <div class="goods-detail">
                                <div class="goods-wrapper">
                                    <div class="goods-pic" v-tips="r.id"><game-item :locked="true" :id="r.id" :num="r.num"></game-item></div>
                                </div> 
                            </div>   
                        </div>                        
                    </div>

                    <div class="max" v-if="!item.tid"><b>{{ $global.max_format($store.state.team.member.length == 1 ? 0 : $store.state.team.member.length , item.max) }}</b>/{{ item.max }}{{ item.label }}</div>
                    <div class="max" v-else><b>{{ $store.state.task['t04'].finishRate ? 1 : 0 }}</b>/{{ item.max }}{{ item.label }}</div>

                    <div class="task-content">{{ item.content }}</div>
                </div>
            </div>
            <div class="u-btn apply sprite sprite-btn-apply" 
            :class="{'dismiss' : $store.state.task['t03'].giftRate == $store.state.task['t03'].finishRate && $store.state.task['t04'].giftRate == $store.state.task['t04'].finishRate,
            'disabled' : $store.state.task['t03'].finishRate == 0 && $store.state.task['t04'].finishRate == 0
            }"
            @click="task_apply()"></div>
        </div>
    </div>
</template>

<script>
import { apiShare,apiTeamtaskApply,apiApplyInfo ,apiTaskApply } from '@/api/index';

export default {
    data(){
        return {
            task_list : [
                {
                    taskName : '二人结义',
                    max : 2,
                    content : '小队成员达到2人',
                    rewards : [{id : 'KR48', name : '活跃自选礼包(7天)' ,num : 3,},{id : 'E559', name : '十万个人士兵' ,num : 2,},],
                    label : '人',
                },
                {
                    taskName : '三人结义',
                    max : 3,
                    content : '小队成员达到3人',
                    rewards : [{id : 'KR48', name : '活跃自选礼包(7天)' ,num : 3,},{id : 'X230', name : '征战印记' ,num : 150,},],
                    label : '人',
                },
                {
                    taskName : '回归匹配一次',
                    max : 1,
                    content : '小队匹配含回归',
                    rewards : [{id : 'HO32', name : '惊魂*戏(30天)' ,num : 1,},{id : 'ON02', name : '高级防具珍材包' ,num : 50,},],
                    label : '次',
                    tid : 'match',
                },
            ],
            team_member : [],
            wait_member : [],
            apply_list : [],
        }
    },
    computed :{
        _team (){
            return this.$store.state.team.member;
        },        
    }, 
    watch : {
        _team : {
            handler(newVal, oldVal) {
                this.member_cnt();                  
            },
            deep: true
        },                 
    },
    mounted(){
        this.member_cnt ();
    },      
    methods : {
        member_cnt (){
            apiApplyInfo().then(
                res => {
                    this.team_member = res.data.member;                    
                    this.wait_member = res.data.applyList.filter(ele => ele.review == 0);
                    this.apply_list = res.data.applyList;
                },
                rej => {},
            )
        },
        call_invite(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            apiShare().then(
                res => {
                    this.$copy_modal({
                        shareTxt : res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url,
                    });               
                },
                rej => {
                    this.$toast(rej.message || '请稍后再试');                   
                },
            )
        },
        call_apply_list (){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            this.$record_modal({ record_list : this.apply_list });
        },
        task_apply(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            apiTaskApply({taskOrderId : [this.$store.state.task['t03'].taskOrderId,this.$store.state.task['t04'].taskOrderId]})
            .then(
                res => {
                    this.$msg_modal({type : 'success' ,})
                    this.$update_evt();
                },
                rej => {
                    this.$toast(rej.message);
                },
            );
        },
    },
}
</script>

<style lang="scss" scoped>
.m-view__team{
    position: relative;
}

.title{
    width: 579px;
    height: 170px;
    margin: 0 auto;
    background-image: url(~@/assets/images/title-3.png);   
}

.slogen{
    color: #ecb785;
    text-align: center;
}

.team-list{
    margin-top: 50px;
    padding: 0 20px;

    .team-item{
        position: relative;
        width: 207px;

        &.t-1{
            height: 363px;
        }

        &.t-2{
            width: 208px;
            transform: translateY(31px);
            height: 371px;
        }
        
        &.t-3{
            height: 363px;
        }

        @for $i from 1 through 3{
            &.t-#{$i}{
                background-image: url(~@/assets/images/player/#{$i}.png);
            }
        }
        
        .u-btn.add{
            position: absolute;
            left: 50%;
            bottom: 145px;
            transform: translateX(-50%);
        }

        .avatar{
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 50%;
            bottom: 70px;
            transform: translateX(-50%);
            width: 92px;
            height: 92px;
            background-image: url(~@/assets/images/bg-avatar.png);

            .label-back{
                position: absolute;
                top: 10px;
                right: 10px;
                width: 23px;
                height: 23px;
                background-image: url(~@/assets/images/icon-return.png);
            }

            img{
                width: 60px;
                height: 60px;
            }
        }
        
        .nickName{
            position: absolute;
            left: 50%;
            bottom: 160px;
            transform: translateX(-50%);
            font-size: 20px;
            color: #fbdebb;  
            width: 80%;
            text-align: center;        
        }
    }
}

.notice{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    font-size: 20px;
    color: #ed9f71;
    text-align: center;

    b{
        font-weight: 400;
        color: #ca3113;
    }
}

.task-view{
    margin-top: 40px;
    padding: 0 20px;
    text-align: center;

    .list-item{
        width: 224px;
        height: 334px;
        padding-left: 16px;
        padding-top: 40px;
        background-image: url(~@/assets/images/item-team.png);
    }

    .task-name{
        position: relative;
        margin: 0 auto 36px;
        font-size: 0;
        //color: #9b4e0a;
        color: transparent;

        p{
            text-align: center;
        }

        &::after{
            content: '';
            display: block;
            position: absolute;
            left: 50%;
            bottom: -24px;
            width: 144px;
            height: 14px;
            transform: translateX(-50%);
            background-image: url(~@/assets/images/item-name.png);
        }        
    }

    .max{
        width: 126px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        margin: 0 auto 15px;
        color: #4e2612;
        background-color: #f6d9a9;
        border-radius: 20px;

        b{
            font-weight: 400;
            color: #ca3113;
        }
    }

    .reward-list{
        margin-bottom: 30px;
        padding: 0 20px;

        .dismiss{
            .goods-wrapper::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 68px;
                height: 68px;
                background-image: url(~@/assets/images/icon-dismiss.png);
                background-repeat: no-repeat;
                background-position: center center;
                pointer-events: none;
            }
        }

    }

    .task-content{
        color: #8a6d52;
    }
}

.u-btn.invite{
    margin: 55px auto 0;
}

.u-btn.apply-list{
    position: absolute;
    right: 0;
    top: 240px;

    &.new{
        &::after{
            content: '';
            display: block;
            position: absolute;
            right: 0px;
            top: 2px;
            width: 15px;
            height: 15px;
            background-image: url(~@/assets/images/icon-new.png);
        }
    }
}

.u-btn.apply{
    margin: 55px auto 0;
}
</style>